import { useEffect, useRef, useState } from 'react';


export const values = {
  defaultSettings: {
    period: '7',
    pageSize: 50,
    pagination: false,
    lang: localStorage.getItem('lang') || 'en',
    mode: "scenarios"
  },

  languages: [
    {
      code: 'en',
      name: 'English'
    },
    {
      code: 'fr',
      name: 'Français'
    },
  ],

  orientations : [
    {
      code: 'portrait',
      name: 'portrait'
    },
    {
      code: 'landscape',
      name: 'landscape'
    }
  ],

  maxReportingPrint: 0 // Change number to 0 to allow an infinite amount of printable columns
};

export const toastTimerValue = 5000;

export const colors = {
  softthinks: '#a91c84',
  success: '#22b222',
  warning: '#ffa600',
  error: '#cc6633'
};


export const roles = {
  dashboardSuperAdmin: -1,
  stAdmin: 0,
  admin: 1,
  user: 2
};

export const sharingValues = {
  noOne: 0,
  everyone: 1,
  allStAdmins: 2,
  allGroupAdmins: 3,
  allGroupUsers: 4
}

export const devicesTypeValues = {
  PCs: 0,              //-	Windows PCs & tablets, macOS x64 devices, Linux devices
  mobiles: 1,          // -	iOS / Android mobiles & tablets
  disks: 2             //-	Disks
}


// export const modules = [
//   "-1", 101, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121,
//   122, 123, 124, 125, 126, 128, 129, 130, 131, /*132,*/ 140, 141, /*142,*/ "004", 143, 144, 145, 150, 151, 152 // 132 vs 142 ???
// ];

export const modules = [  //  modules new references...
  "-1", 1101, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1120, 1121, 1122, 1123, 1124,
  1125, 1126, 1127, 1128, 1129, 1130, 1131, 1132, 1133, 1134, 1135, 1136, 1137, 1138, 1139, 1140, 1141, 1144
];

export const modulesGeneral_Values = [
  'deployment_id', 'serial', 'mac', 'server_name'
];

export const moduleValues = {
  [1101]: [
    'asset_tag', 'exit_code',
    'gts_number', 'user_click',
    'combo_list', 'id',
    'selection_1', 'auditor_name',
    'nt_tag', 'po_number',
    'user_id', 'vendor_id',
    'asset_number'
  ],

  [1103]: [],

  [1104]: [
    'image_selected',
    'os_version',
    'sdkdb_folder',
    'size'],

  [1105]: [],

  [1107]: [
    'selected_profil'
  ],

  [1108]: [],

  [1109]: [],

  [1110]: [],

  [1111]: [
    'recovery_language',
    'recovery_partition_pos',
    'recovery_partition_visibility',
    'recovery_solution'
  ],

  [1112]: [
    'boot_disk_name',
    'boot_disk_size'
  ],

  [1113]: [
    'launched_cmd',
    'process_error_code',
    'process_status',
    'precheck_result'
  ],

  [1114]: [
    'boot_files_status',
    'disk_number',
    'mbr_status',
    'partition_table_status',
    'partitions_status'
  ],

  [1115]: [
    'deployment_type',
    'image_deployment_type',
    'image_to_populate',
    'image_type'
  ],

  [1116]: [
    'batch_ini',
    'fix_boot_files',
    'set_audit_mode',
    'standard_mbr',
    'updmst_launch',
    'boot_partition_activation'
  ],

  [1117]: [],

  [1118]: [],

  [1119]: [
    'deploy_duration',
    'deploy_status',
    'message_level_0',
    'message_level_1',
    'process_bios',
    'message_level_2'
  ],

  [1120]: [
    'additional_disk',
    'irst_param',
    'partition_filesystem',
    'partition_name',
    'partition_size',
    'partition_type',
    'system_disk',
    'system_disk_4k',
    'system_disk_layout'
  ],

  [1121]: [],

  [1122]: [
    'files_restored'
  ],

  [1123]: [
    'Added_CaptureDate',
    'Added_ImageName',
    'Added_OsArchitecture',
    'Added_OsVersion',
    'Added_UsedSpace'
  ],

  [1124]: [],

  [1125]: [
    'copy_ris',
    'envfiles_folder',
    'ris_local_folder',
    'SBAR_activation_code',
    'SBAR_activation_result',
    'SBAR_activation_type',
    'SBAR_image'
  ],

  [1126]: [
    'disk_bps',
    'disk_bus',
    'disk_commercial_size',
    'disk_customer_data',
    'disk_dco',
    'disk_firmware',
    'disk_formfactor',
    'disk_health',
    'disk_hpa',
    'disk_model',
    'disk_model_real',
    'disk_path',
    'disk_ppid',
    'disk_sectors',
    'disk_serial',
    'disk_serial_real',
    'disk_size',
    'disk_smart_5',
    'disk_smart_attribut',
    'disk_smart_available_spare',
    'disk_vendor',
    'wipe_algo',
    'wipe_algo_eraser_rounds',
    'wipe_result',
    'wipe_time',
    'wipe_uuid',
    'wipe_algo_forced_loop',
    'disk_logical_count',
    'disk_logical_item',
    'Nb Disks wiped',
    'disk_orderLot'
  ],

  [1127]: [],

  [1128]: [],  

  [1130]: [],

  [1131]: [
    'disk_model',
    'disk_serial',
    'test_result'
  ],

  [1134]: [
    'battery_status',
    'generic_recovery_partition',
    'has_valid_recovery',
    'migration',
    'user_partition'
  ],

  [1136]: [
    'Battery Wear Level_1',
    'Dead Pixel Test_100',
    'Result: Battery Wear Level',
    'Result: Dead Pixel Test',
    'Result: Internal Microphone',
    'Result: Internal Speaker',
    'Result: Touchpad',
    'Result: Webcam',
    'Result: Wi-Fi (WAN)',
    'Result: Wired (LAN)',
    'Touchpad_131',
    'Wi-Fi (WAN)_51',
    'Wired (LAN)_50',
    'Display Ports_80',
    'Internal Microphone_21',
    'Internal Speaker_20',
    'Result: Display Ports',
    'Result: Keyboard Status LED',
    'Result: SMART Attributes',
    'Result: USB Ports',
    'Result: Wi-Fi (WLAN)',
    'SMART Attributes_14',
    'Battery Charging Test_2',
    'Battery Drain Test_3',
    'Card Reader_70',
    'Clavier_30',
    'Combo Jack_24',
    'Haut-parleur interne_20',
    'HDD Random Read Test_13',
    'HDD Short SMART Test_10',
    'Keyboard_30',
    'Lid Sensor_90',
    'Microphone interne_21',
    'Ports USB_120',
    'Result: 2D Lines and bitmaps',
    'Result: Battery Charging Test',
    'Result: Battery Drain Test',
    'Result: Câblé (LAN)',
    'Result: Card Reader',
    'Result: Clavier',
    'Result: Combo Jack',
    'Result: CPU Full Test',
    'Result: General purpose instructions',
    'Result: Haut-parleur interne',
    'Result: HDD Random Read Test',
    'Result: HDD Short SMART Test',
    'Result: IDS_Test_CPU_SFT',
    'Result: Input Jack',
    'Result: Keyboard',
    'Result: Lid Sensor',
    'Result: Microphone interne',
    'Result: MMX',
    'Result: Mouse',
    'Result: Output Jack',
    'Result: Ports USB',
    'Result: RAM',
    'Result: Screen Calibration Test',
    'Result: Test de l´écran',
    'Result: Test de lecture aléatoire du disque dur',
    'Result: TrackPoint',
    'Screen Calibration Test_101',
    'Test de l´écran_100',
    'Test de lecture aléatoire du disque dur_13',
    'USB Ports_120',
    'Webcam_140',
    'HDD SMART Status_15',
    'Result: 2D Local video memory',
    'Result: Floating Point Unit instructions',
    'Result: HDD SMART Status',
    'Result: Maximum heat',
    'Result: Touchscreen',
    'Touchscreen_132',
    'Optical Drive Read Test_40',
    'Result: Optical Drive Read Test'
  ],

  [1137]: [
    'Trade-In code'
  ],

  [1138]: [],

  [1139]: [],

  [1141]: [
    'disk_attributs',
    'disk_checked',
    'disk_sector_checked'
  ],

  [1144]: [],

  [1140]: [],  // lot of different data : user data ??

  [1129]: []
}


export const formatReportingHeader = (t, category, column, parentTitle = null) => {

  // console.log("348 - category=", category);
  // console.log("349 - column=", column);
  // console.log("350 - parentTitle=", parentTitle);

  if (parentTitle) {
    // console.log("49 - txt=", `${parentTitle} \u2013 ${t(`reporting.columns.${category}.sub_title`)} \u2013 ${t(`reporting.columns.${category}.${column}`)}`);
    // console.log("355 - txt=", t('reporting.columns.' + category + '.' + column));

    return (
      `${t(parentTitle)} \u2013 ${t(`reporting.columns.${category}.sub_title`)} \u2013 ${t(`reporting.columns.${category}.${column}`)}`
    );
  }
  else {

    return (
      `${t(`reporting.columns.${category}.sub_title`)} \u2013 ${t(`reporting.columns.${category}.${column}`)}`
    );
  }
};


export const handlePromptScrollShadow = (initialCheck) => {
  const prompt = document.querySelector('.prompt__wrapper');
  if (!prompt) return;

  const actions = document.querySelector('.prompt__actions');
  // Adding 1 is necessary because display scaling can give decmial undervalues.
  const isBottom = (prompt.scrollTop + 1) >= prompt.scrollHeight - prompt.clientHeight;

  if (initialCheck !== true) actions.style.transition = 'box-shadow 0.25s';
  actions.style.boxShadow = isBottom ? 'none' : '';
};


export const getRole = (role) => {
  const roles = {
    '-1': "Dashboard Super Administrator",
    0: 'SoftThinks Administrator',
    1: 'Administrator',
    2: 'User'
  };
  return roles[role];
};


export const useStateWithCallback = (initialState) => {
  const [state, setState] = useState(initialState);
  const callbackRef = useRef(() => undefined);

  const setStateCB = (newState, callback = () => null) => {
    callbackRef.current = callback;
    setState(newState);
  };

  useEffect(() => { callbackRef.current?.(); }, [state]);
  return [state, setStateCB];
};


export const transcodeBrand = (brand) => {
  if (brand.startsWith('advent'))
    return 'Advent';

  if (brand.startsWith('alienware'))
    return 'Alienware';

  if (brand.startsWith('acer'))
    return 'Acer';

  if (brand.startsWith('apple'))
    return 'Apple';

  if (brand.startsWith('asus'))
    return 'ASUS';

  if (brand.startsWith('auchan'))
    return 'Auchan';

  if (brand.startsWith('bytespeed'))
    return 'ByteSpeed';

  if (brand.startsWith('compaq'))
    return 'Compaq';

  if (brand.startsWith('dell'))
    return 'Dell';

  if (brand.startsWith('ecs'))
    return 'ECS';

  if (brand.startsWith('emachines'))
    return 'eMachines';

  if (brand.startsWith('equus'))
    return 'EQUUS';

  if (brand.startsWith('essentielb') || brand.startsWith('essentiel b'))
    return 'Essentiel b';

  if (brand.startsWith('filla'))
    return 'Filla';

  if (brand.startsWith('fujitsu'))
    return 'Fujitsu';

  if (brand.startsWith('gateway'))
    return 'Gateway';

  if (brand.startsWith('gigabyte'))
    return 'Gigabyte';

  if (brand.startsWith('hp') || brand.startsWith('hewlett-packard'))
    return 'HP';

  if (brand.startsWith('huawei'))
    return 'Huawei';

  if (brand.startsWith('ibm'))
    return 'IBM';

  if (brand.startsWith('innotek'))
    return 'InnoTek';

  if (brand.startsWith('intel'))
    return 'Intel';

  if (brand.startsWith('lenovo'))
    return 'Lenovo';

  if (brand.startsWith('lg'))
    return 'LG';

  if (brand.startsWith('medion'))
    return 'Medion';

  if (brand.startsWith('microsoft'))
    return 'Microsoft';

  if (brand.startsWith('micro-star international') || brand.startsWith('msi'))
    return 'MSI';

  if (brand.startsWith('motion'))
    return 'Motion';

  if (brand.startsWith('nec'))
    return 'NEC';

  if (brand.startsWith('packarb bell') || brand.startsWith('packard bell') || brand.startsWith('packardbell'))
    return 'Packard Bell';

  if (brand.startsWith('panasonic'))
    return 'Panasonic';

  if (brand.startsWith('pc specialist'))
    return 'PC Specialist';

  if (brand.startsWith('pegatron'))
    return 'PEGATRON';

  if (brand.startsWith('qilive'))
    return 'Qilive';

  if (brand.startsWith('razer'))
    return 'RAZER';

  if (brand.startsWith('samsung'))
    return 'Samsung';

  if (brand === 'si')
    return 'Si';

  if (brand.startsWith('sony'))
    return 'Sony';

  if (brand.startsWith('toshiba'))
    return 'Toshiba';

  if (brand.startsWith('vmware'))
    return 'VMware';

  return '';
};
